import "./styles.css";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import OutputTransmedProcess from "../../../../dtos/transmed/process/process";
import TransmedProcessAnnouncement from "./announcement";
import { Navigation, Pagination } from "swiper/modules";
import TransmedProcessRegistration from "./registration";
import { TransmedRegistrationStage } from "../../../../dtos/transmed/process/registration/registration";
import TransmedProcessSubmitted from "./submitted";
import TransmedProcessRejected from "./rejected";
import TransmedProcessValid from "./valid";
import TransmedProcessRanking from "./ranking";
import { createContext, useState } from "react";
import { ErrorMessageContext } from "../../../generic-error";
import TransmedProcessNoPlace from "./noPlace";
import TransmedProcessRevoked from "./revoked";
import TransmedProcessAccepted from "./accepted";
import TransmedProcessDistribution, {
  endBatch,
  startBatch,
} from "./distribution";
import TransmedProcessChosing from "./chosing";
import TransmedProcessDistributed from "./distributed";
import TransmedProcessConfirmed from "./confirmed";
import TransmedProcessCertificate from "./certificate";

export const RegulationsContext = createContext<string>("");

function TransmedProcess({ process }: { process: OutputTransmedProcess }) {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);

  return (
    <ErrorMessageContext.Provider value={[errorMessage, setErrorMessage]}>
      <RegulationsContext.Provider value={process.regulations}>
        <section
          className="transmed-process content-container"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            color: "var(--color-dark)",
          }}
        >
          <Swiper
            allowTouchMove={false}
            simulateTouch={false}
            navigation={true}
            pagination={{
              dynamicBullets: true,
            }}
            watchOverflow={false}
            modules={[Navigation, Pagination]}
            style={{ width: "100%" }}
            initialSlide={100}
            onSwiper={setSwiper}
          >
            <SwiperSlide>
              <TransmedProcessAnnouncement
                periodText={process.period_text}
                announcement={process.announcement}
                expired={process.expired}
                transmedAvailable={process.transmedAvailable}
                existsRegistration={
                  (process.form?.registration ?? null) !== null
                }
              />
            </SwiperSlide>
            {process.transmedAvailable && (
              <>
                {process.form && (
                  <SwiperSlide>
                    <TransmedProcessRegistration
                      form={process.form}
                      periodText={process.period_text}
                      receivings={process.announcement!.receivings}
                      registration_end={process.announcement!.registration_end}
                      onSubmit={() => swiper?.slideNext()}
                    />
                  </SwiperSlide>
                )}
                {process.form &&
                  process.form.registration !== null &&
                  (process.form.registration.stage ===
                  TransmedRegistrationStage.submitted ? (
                    <SwiperSlide>
                      <TransmedProcessSubmitted
                        sections={process.form.sections}
                        registration={process.form.registration}
                      />
                    </SwiperSlide>
                  ) : process.form.registration.stage ===
                    TransmedRegistrationStage.rejected ? (
                    <SwiperSlide>
                      <TransmedProcessRejected
                        rejection_message={
                          process.form.registration.rejection_message
                        }
                        question={process.form.registration.question}
                        answer={process.form.registration.answer}
                        contesting_deadline={process.form.points_deadline_first}
                      />
                    </SwiperSlide>
                  ) : (
                    (process.form.registration.stage ===
                      TransmedRegistrationStage.valid ||
                      process.form.registration.stage ===
                        TransmedRegistrationStage.chosing ||
                      process.form.registration.stage ===
                        TransmedRegistrationStage.distributed ||
                      process.form.registration.stage ===
                        TransmedRegistrationStage.confirmed ||
                      process.form.registration.stage ===
                        TransmedRegistrationStage.accepted ||
                      process.form.registration.stage ===
                        TransmedRegistrationStage.revoked ||
                      process.form.registration.stage ===
                        TransmedRegistrationStage.no_place) &&
                    (process.ranking === null ? (
                      <SwiperSlide>
                        {process.form.registration.stage ===
                        TransmedRegistrationStage.accepted ? (
                          <TransmedProcessAccepted
                            registration={process.form.registration}
                            exchangeStart={
                              process.announcement?.receivings.find(
                                (receiving) =>
                                  receiving.lc.id ===
                                  process.form?.registration?.confirmed_lc!.id
                              )?.exchange_start!
                            }
                            exchangeEnd={
                              process.announcement?.receivings.find(
                                (receiving) =>
                                  receiving.lc.id ===
                                  process.form?.registration?.confirmed_lc!.id
                              )?.exchange_end!
                            }
                            receiving={
                              process.announcement?.receivings.find(
                                (receiving) =>
                                  receiving.lc.id ===
                                  process.form?.registration?.confirmed_lc!.id
                              )!
                            }
                            participationProofTemplate={
                              process.participation_proof_template
                            }
                          />
                        ) : (
                          <TransmedProcessValid
                            sections={process.form.sections}
                            registration={process.form.registration}
                            pointsDeadlineFirst={
                              process.form.points_deadline_first
                            }
                            points={process.form.registration.points}
                          />
                        )}
                      </SwiperSlide>
                    ) : (
                      <>
                        <SwiperSlide>
                          <TransmedProcessRanking
                            registration={process.form.registration}
                            ranking={process.ranking}
                            final={process.distribution !== null}
                          />
                        </SwiperSlide>
                        {process.distribution !== null && (
                          <SwiperSlide>
                            {process.form.registration.stage ===
                            TransmedRegistrationStage.valid ? (
                              <TransmedProcessDistribution
                                start={process.distribution.start}
                                batch={process.form.registration.batch ?? -1}
                                receivings={process.announcement!.receivings}
                                details={process.distribution.receivings}
                              />
                            ) : process.form.registration.stage ===
                              TransmedRegistrationStage.chosing ? (
                              <TransmedProcessChosing
                                registration={process.form.registration}
                                details={process.distribution.receivings}
                                receivings={process.announcement!.receivings}
                                deadline={endBatch(
                                  process.distribution.start,
                                  process.form.registration.batch!
                                )}
                                startNext={startBatch(
                                  process.distribution.start,
                                  process.form.registration.batch! + 1
                                )}
                                endNext={endBatch(
                                  process.distribution.start,
                                  process.form.registration.batch! + 1
                                )}
                                passed={process.form.registration.passed}
                              />
                            ) : process.form.registration.stage ===
                              TransmedRegistrationStage.distributed ? (
                              <TransmedProcessDistributed
                                registration={process.form.registration}
                                deadline={endBatch(
                                  process.distribution.start,
                                  process.form.registration.batch!
                                )}
                                passed={process.form.registration.passed}
                              />
                            ) : process.form.registration.stage ===
                              TransmedRegistrationStage.confirmed ? (
                              <TransmedProcessConfirmed
                                details={process.distribution.receivings}
                                registration={process.form.registration}
                                deadline={endBatch(
                                  process.distribution.start,
                                  process.form.registration.batch!
                                )}
                                startNext={startBatch(
                                  process.distribution.start,
                                  process.form.registration.batch! + 1
                                )}
                                endNext={endBatch(
                                  process.distribution.start,
                                  process.form.registration.batch! + 1
                                )}
                              />
                            ) : process.form.registration.stage ===
                              TransmedRegistrationStage.accepted ? (
                              <TransmedProcessAccepted
                                registration={process.form.registration}
                                exchangeStart={
                                  process.announcement?.receivings.find(
                                    (receiving) =>
                                      receiving.lc.id ===
                                      process.form?.registration?.confirmed_lc!
                                        .id
                                  )?.exchange_start!
                                }
                                exchangeEnd={
                                  process.announcement?.receivings.find(
                                    (receiving) =>
                                      receiving.lc.id ===
                                      process.form?.registration?.confirmed_lc!
                                        .id
                                  )?.exchange_end!
                                }
                                receiving={
                                  process.announcement?.receivings.find(
                                    (receiving) =>
                                      receiving.lc.id ===
                                      process.form?.registration?.confirmed_lc!
                                        .id
                                  )!
                                }
                                participationProofTemplate={
                                  process.participation_proof_template
                                }
                              />
                            ) : process.form.registration.stage ===
                              TransmedRegistrationStage.revoked ? (
                              <TransmedProcessRevoked
                                message={
                                  process.form.registration.rejection_message
                                }
                              />
                            ) : (
                              <TransmedProcessNoPlace />
                            )}
                          </SwiperSlide>
                        )}
                      </>
                    ))
                  ))}
                {process.form &&
                  process.form.registration &&
                  process.form.registration.stage ===
                    TransmedRegistrationStage.accepted &&
                  process.certificate &&
                  process.certificate.start < new Date() &&
                  (process.certificate.start.getFullYear() !==
                    new Date().getFullYear() ||
                    process.certificate.start.getMonth() !==
                      new Date().getMonth() ||
                    process.certificate.start.getDate() <
                      new Date().getDate()) && (
                    <SwiperSlide>
                      <TransmedProcessCertificate
                        registration={process.form.registration}
                        certificate={process.certificate}
                      />
                    </SwiperSlide>
                  )}
              </>
            )}
          </Swiper>
        </section>
      </RegulationsContext.Provider>
    </ErrorMessageContext.Provider>
  );
}

export default TransmedProcess;
